import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { icons } from '@tsq-web/assets';

@Component({
  selector: 'comm-neighbor-mass-invite-invites-sent-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      class="hover:bg-petro-n1 text-new-primary-p2 focus:outline-new-primary mb-16 rounded transition-colors focus:outline focus:outline-offset-2"
      (click)="goBack.emit()"
    >
      <tsq-icon [icon]="arrowLeftIcon" />
    </button>

    <h1>{{ 'MASS_INVITE_NEIGHBORS.SUCCESS_TITLE_V2' | translate }}</h1>

    <p class="text-md mt-8 w-[400px] leading-normal">
      {{ 'MASS_INVITE_NEIGHBORS.INVITES_SENT' | translate }}
    </p>

    <tsq-button
      class="mt-40"
      schema="new-primary"
      size="lg"
      [text]="'MASS_INVITE_NEIGHBORS.SUCCESS_BACK' | translate"
      (clicked)="goToCommunity.emit()"
    />
    <tsq-button
      class="mt-16"
      schema="new-primary"
      size="lg"
      kind="secondary"
      [text]="'MASS_INVITE_NEIGHBORS.SEND_MORE_INVITES' | translate"
      (clicked)="goBack.emit()"
    />
  `,
})
export class InvitesSentCardComponent {
  @Output() goBack = new EventEmitter<void>();
  @Output() goToCommunity = new EventEmitter<void>();

  protected readonly arrowLeftIcon = icons.arrowLeft;
}
